import { render } from "./SidenavItem.vue?vue&type=template&id=6ede82dd&scoped=true&ts=true"
import script from "./SidenavItem.vue?vue&type=script&lang=ts"
export * from "./SidenavItem.vue?vue&type=script&lang=ts"

import "./SidenavItem.vue?vue&type=style&index=0&id=6ede82dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ede82dd"],['__file',"src/views/components/Sidenav/SidenavItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ede82dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ede82dd', __exports__)) {
    api.reload('6ede82dd', __exports__)
  }
  
  module.hot.accept("./SidenavItem.vue?vue&type=template&id=6ede82dd&scoped=true&ts=true", () => {
    api.rerender('6ede82dd', render)
  })

}


export default __exports__